export { dmsCommandsFetchingAtom } from './dmsCommands.recoil.atom';
export { credentialsAtom } from '../../auth/core/auth.recoil';
export {
  hasLegalDocsToAcceptAtom,
  legalDocumentsAtom,
  legalDocumentsAcceptanceAtom,
} from './legalDocuments.recoil.atom';
export * from './types';
